// consts

const FS_MIN = 12;
const FS_MAX = 38;
const FS_STEP = 2;

const LH_MIN = 1.0;
const LH_MAX = 3.0;
const LH_STEP = 0.1;

const novelDefaults = {
  bg: "white",
  fs: 18,
  lh: 1.5
};

const bgToColors = {
  black: [
    ["backgroundColor", "black"],
    ["color", "#f4f4f4"]
  ],
  white: [
    ["backgroundColor", "white"],
    ["color", "#111"]
  ]
};

const settingToPayload = {
  bg: val => bgToColors[val],
  fs: val => [["fontSize", `${val}px`]],
  lh: val => [["lineHeight", val]]
};

function payloadFromSettings() {
  return Object.entries(getStoredNovelSettings()).map(([key, val]) => settingToPayload[key](val));
}

function storeNovelSetting([key, val]) {
  localStorage.setItem(`__pop__${key}`, val);
}

const novelSettingsUpdaters = {
  setBgBlack(_settings) {
    return ["bg", "black"];
  },

  setBgWhite(_settings) {
    return ["bg", "white"];
  },

  setFsBigger({ fs }) {
    return ["fs", Math.min(fs + FS_STEP, FS_MAX)];
  },

  setFsSmaller({ fs }) {
    return ["fs", Math.max(fs - FS_STEP, FS_MIN)];
  },

  setLhBigger({ lh }) {
    return ["lh", Math.min(lh + LH_STEP, LH_MAX)];
  },

  setLhSmaller({ lh }) {
    return ["lh", Math.max(lh - LH_STEP, LH_MIN)];
  }
};

function makeSettingsHandlers(iframe, updater) {
  const postMsgToIframe = postToIframe(iframe);
  return function effectfulSettingsHandler(state) {
    const [key, val] = updater(state);
    storeNovelSetting([key, val]);
    postMsgToIframe(settingToPayload[key](val));
    return { [key]: val };
  };
}

function postToIframe(iframe) {
  return function doPostToIframe(payload) {
    iframe.contentWindow.postMessage({ type: "setReaderStyle", payload }, "*");
  };
}

export function getStoredNovelSettings() {
  return {
    bg: localStorage.getItem("__pop__bg") || novelDefaults.bg,
    fs: parseInt(localStorage.getItem("__pop__fs") || novelDefaults.fs),
    lh: parseFloat(localStorage.getItem("__pop__lh") || novelDefaults.lh)
  };
}

export function setupNovelSettingsHandlers(iframe) {
  return Object.entries(novelSettingsUpdaters).reduce(
    (agg, [key, val]) => Object.assign(agg, { [key]: makeSettingsHandlers(iframe, val) }),
    {}
  );
}

export function postAllToIframe(iframe) {
  payloadFromSettings().forEach(postToIframe(iframe));
}
